import React, { useState, useEffect, useContext } from 'react';
import { LangContext } from '../../../App'
import String from '../../../Assets/Localization/Local'
import { Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import axios from 'axios';
import './ServiceModalStyle.css';
import { Modal } from 'antd';
import { API_ENDPOINT } from '../../../AppConfig'
import cookie from 'react-cookies'
import './ServiceModalStyle.css'
import Lottie from 'react-lottie';
import animationData from '../../../Assets/lottieFiles/loadding.json';


const ServiceModal = (props) => {

  console.log('props=>ServiceModal ', props)

  const [show, setShow] = useState(false);
  const [showLottie, setShowLottie] = useState(false);
  const [specialtyData, setSpecialtyData] = useState([])
  const { lang } = useContext(LangContext)

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  useEffect(() => {
    setShowLottie(true)
    let uri = `${API_ENDPOINT}/specialty`
    let token_cookie = cookie.load("HB_token");
    let token_sessionStorage = JSON.stringify(sessionStorage.getItem("HB_token"));
    let token = `Bearer ${token_cookie ? token_cookie : token_sessionStorage}`
    axios.get(uri, {
      headers: {
        'Authorization': token,
        'Accept-Language': lang
      }
    }).then(response => {
      console.log('get all specialty done=> ', response.data)
      setSpecialtyData(response.data.data)
      setShow(true)
      setShowLottie(false)
    }).catch(error => {
      console.log('get all specialty error=> ', error.response)
    })
  }, [])

  const handleCancel = () => {
    setShow(false)
  }

  const cancelAllProcess = () => {
    setShow(false)
    setShowLottie(false)
  }

  return (
    showLottie === true ?
      <Modal
        visible={showLottie}
        centered
        footer={null}
        onCancel={cancelAllProcess}
      >
        <Row className="m-0">
          <Col lg="12" className="viewprescriptionmodal"></Col>
          <Col lg="12" >
            <Lottie options={defaultOptions}
              height={250}
              width={250}
            />
          </Col>
        </Row>

      </Modal>
      :
      show === true ?
        <Modal
          title={null}
          visible={show}
          footer={null}
          onCancel={handleCancel}
          centered
        >
          <Row className="m-0">
            <Col lg="12" className="viewprescriptionmodal"> <h3>{String.sectionsTitle}</h3></Col>
            {specialtyData.map((ele, index) => {
              return (
                <Col lg="6" md="6"  >
                  <div className="ColStyle">
                    <Link to={{
                      pathname: "/HealthBook-Web/AddPrescription",
                      state: { obj: ele, user: props.user, userType: props.userType }
                    }}>{ele.name}</Link>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Modal>
        :
        null
  )
}

export default ServiceModal;